import { render, staticRenderFns } from "./OrderableItems.vue?vue&type=template&id=3d9c6690&"
import script from "./OrderableItems.vue?vue&type=script&lang=ts&"
export * from "./OrderableItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports